import { InvoiceSummary } from 'types';
import { InvoiceStatus } from 'enums';

export const isNotPostedExceptionReview = ({ postStatusAp, voucherMatchStatus, voucherInApReview }: InvoiceSummary) =>
    voucherInApReview === 'Y' || (postStatusAp === 'U' && voucherMatchStatus === 'E');

export const filterByStatus = (status: InvoiceStatus, invoice: InvoiceSummary) => {
    const { paymentDate, paymentHoldFlag, scheduledPayDate } = invoice;

    switch (status) {
        case InvoiceStatus.Paid: return Boolean(paymentDate);
        case InvoiceStatus.ScheduledToPay: return Boolean(scheduledPayDate && !isNotPostedExceptionReview(invoice));
        case InvoiceStatus.PaymentOnHold: return paymentHoldFlag === 'Y' && !isNotPostedExceptionReview(invoice);
        case InvoiceStatus.PaymentInReview: return isNotPostedExceptionReview(invoice);
        default: return true;
    }
};
